export default function CTASection() {
  return (
    <section className="bg-[#6B8FA3]">
      <div className="section-padding">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-6">
            Let&apos;s Work Together
          </h2>
          <p className="text-base mb-8 leading-relaxed max-w-xl mx-auto text-background-100/90">
            My Energy-Safe coaching is for people navigating chronic illness, ADHD/Autism sensory drain, or a life whose demands outpace their capacity. Together, we use Energy-Safe Motions to break the Boom &amp; Bust cycle. Book a free conversation and let&apos;s explore what&apos;s possible.
          </p>
          <a
            href="https://calendly.com/federicatedeschi3/new-meeting"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#2C3E6B] text-white px-10 py-4 rounded-lg font-semibold text-base hover:opacity-90 hover:scale-[1.05] hover:-translate-y-[3px] hover:shadow-xl transition-all duration-300 ease-out shadow-card whitespace-nowrap cursor-pointer"
          >
            Book a Free Conversation
          </a>
        </div>
      </div>

      {/* Wave Divider */}
      <div className="w-full overflow-hidden leading-none">
        <svg
          className="relative block w-full h-[60px] md:h-[80px]"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C59.71,118.11,140.83,94.17,321.39,56.44Z"
            fill="#6B8FA3"
            fillOpacity="0.15"
          />
          <path
            d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,95.8V120H1200V15.81C1132.19,35.17,1056.71,43.32,985.66,92.83Z"
            fill="#6B8FA3"
            fillOpacity="0.3"
          />
        </svg>
      </div>
    </section>
  );
}